'use client';

import type { CSSProperties, ReactNode } from 'react';
import { Box, VStack } from '@terra/ui-styled-system';
import {
  CVSS_METRIC_COLUMN_GAP_PX,
  CVSS_METRIC_COLUMN_MIN_WIDTH_PX,
} from '../../object-edit-page/objectEditLayoutTokens';

const COLUMN_STYLE: CSSProperties = {
  flex: `1 1 ${CVSS_METRIC_COLUMN_MIN_WIDTH_PX}px`,
  minWidth: `min(${CVSS_METRIC_COLUMN_MIN_WIDTH_PX}px, 100%)`,
};

const ROW_STYLE: CSSProperties = {
  gap: `${CVSS_METRIC_COLUMN_GAP_PX}px`,
};

export function MetricColumns({
  left,
  right,
}: {
  left: ReactNode;
  right: ReactNode;
}) {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="flex-start"
      w="full"
      style={ROW_STYLE}
    >
      <VStack gap={3} alignItems="stretch" style={COLUMN_STYLE}>
        {left}
      </VStack>
      <VStack gap={3} alignItems="stretch" style={COLUMN_STYLE}>
        {right}
      </VStack>
    </Box>
  );
}
